import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getPurchaseRequests = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/PurchaseRequest/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching purchase requests:", error);
    throw error;
  }
};

export const savePurchaseRequest = async (purchaseRequest) => {
  const response = await axios.post(`${BASE_URL}/api/PurchaseRequest/save`, purchaseRequest, {
    headers: getAuthHeader(),
  });
  return response.data;
};

export const getNextOrderNo = async (businessId) => {
  try {
    const payload = {
      Business_Id: businessId
    };
    
    const response = await axios.post(`${BASE_URL}/api/PurchaseRequest/get-next-order-no`, payload, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error getting next order number:", error);
    throw error;
  }
};

export const markPurchaseRequestAsReceived = async (purchaseRequestId) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/PurchaseRequest/mark-as-received`, {
      PurchaseRequest_Id: purchaseRequestId
    }, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error marking purchase request as received:", error);
    throw error;
  }
};


